/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RelationshipType } from './RelationshipType';
import {
    RelationshipTypeFromJSON,
    RelationshipTypeFromJSONTyped,
    RelationshipTypeToJSON,
    RelationshipTypeToJSONTyped,
} from './RelationshipType';

/**
 * A referral code that is used for tracking the onboarding of users.
 * @export
 * @interface ReferralCode
 */
export interface ReferralCode {
    /**
     * 
     * @type {string}
     * @memberof ReferralCode
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralCode
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralCode
     */
    welcomeEmailTemplate?: string;
    /**
     * 
     * @type {RelationshipType}
     * @memberof ReferralCode
     */
    relationshipType: RelationshipType;
    /**
     * Optional Challenge association for challenge-scoped referral codes. Null for the user's global referral code.
     * @type {string}
     * @memberof ReferralCode
     */
    challengeId?: string;
    /**
     * 
     * @type {number}
     * @memberof ReferralCode
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralCode
     */
    updatedAt?: number;
}



/**
 * Check if a given object implements the ReferralCode interface.
 */
export function instanceOfReferralCode(value: object): value is ReferralCode {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('relationshipType' in value) || value['relationshipType'] === undefined) return false;
    return true;
}

export function ReferralCodeFromJSON(json: any): ReferralCode {
    return ReferralCodeFromJSONTyped(json, false);
}

export function ReferralCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralCode {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'welcomeEmailTemplate': json['welcomeEmailTemplate'] == null ? undefined : json['welcomeEmailTemplate'],
        'relationshipType': RelationshipTypeFromJSON(json['relationshipType']),
        'challengeId': json['challengeId'] == null ? undefined : json['challengeId'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}

export function ReferralCodeToJSON(json: any): ReferralCode {
    return ReferralCodeToJSONTyped(json, false);
}

export function ReferralCodeToJSONTyped(value?: ReferralCode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'welcomeEmailTemplate': value['welcomeEmailTemplate'],
        'relationshipType': RelationshipTypeToJSON(value['relationshipType']),
        'challengeId': value['challengeId'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

